import reducer from "./reducers";

import * as busquedasOps from "./operations";
import * as busquedasTypes from "./types";

export { busquedasOps, busquedasTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/busquedas/index.js